import axios from "axios";
import { GlobalError } from "components/errors/GlobalError";
import React from "react";
import { LOGIN_USER } from "store/actions/actionTypes/types";
import {
  generateConfig,
  GetApplication,
  GetApplicationVersion,
} from "utilityFunctions";

export const autoLogin = async (
  email: string,
  password: string,
  qrTokenToValidate: string | undefined,
  language: string,
  dispatch: any,
  setRedirect?: React.Dispatch<React.SetStateAction<boolean>>
) => {

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const loginRequest = {
    application: await GetApplication(),
    applicationVersion: GetApplicationVersion(),
    password: password,
    usernameOrEmail: email?.toLowerCase(),
    qrTokenToValidate: qrTokenToValidate,
  };
  try {
    const loginResponse = await axios.post(
      `${BASE_URL}/api/auth/login`,
      loginRequest,
      {
        headers: {
          "Accept-Language": language === "en" ? "en-US;" : "fr-CA;",
        },
      }
    );
    if (loginResponse.status === 200) {
      const token = loginResponse.data.accessToken;
      const refreshToken = loginResponse.data.refreshToken;
      const config = generateConfig(token);

      const userInfoResponse = await axios.get(
        `${BASE_URL}/api/users/info`,
        config
      );
      const userInfo = userInfoResponse.data;

      const payloadObject = {
        accessToken: token,
        userInfo,
        refreshToken,
      };

      const persistentLogin = true;

      dispatch({ type: LOGIN_USER, payload: payloadObject });
      if (persistentLogin) {
        window.localStorage.setItem("user", JSON.stringify(payloadObject));
      } else {
        window.sessionStorage.setItem("user", JSON.stringify(payloadObject));
      }
      if (!!setRedirect) {
        setRedirect(true);
      }
    }
  } catch (error) {
    GlobalError(error);
  }
};
